<template>
     <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div id="container1" class="modal-container">

              <div class="modal-header">
                <slot name="header">
                  <h3>Медицинская карта № {{card.cardid}}</h3>
                </slot>
              </div>

              <div class="modal-body" v-bind:style="heightClass()">
                <slot name="body">
                  <div style="display:flex; flex-direction:column">
                      <div>
                          <span class="nameProperty">1. Дата заполнения медицинской карты: </span> 
                          <span v-if="card.data && card.data['Дата заполнения медицинской карты']">{{card.data['Дата заполнения медицинской карты']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">2. ФИО: </span> {{card.lastName}} {{card.firstName}} {{card.middleName}}
                      </div>
                      <div>
                          <span class="nameProperty">3. Пол: </span> {{card.gender}}
                      </div>
                      <div>
                          <span class="nameProperty">4. Дата рождения: </span> {{new Date(card.birthDay).toLocaleString('ru', {day: 'numeric', month: 'long', year: 'numeric'})}}
                      </div>
                      <div>
                          <span class="nameProperty">5. Место регистрации: </span> 
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['субъект Российской Федерации']"> субъект РФ: {{card.data['Место регистрации']['субъект Российской Федерации']}} </span>
                          <span v-else> - </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['район']"> субъект РФ: {{card.data['Место регистрации']['район']}} </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['город']"> субъект РФ: {{card.data['Место регистрации']['город']}} </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['населенный пункт']"> субъект РФ: {{card.data['Место регистрации']['населенный пункт']}} </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['улица']"> субъект РФ: {{card.data['Место регистрации']['улица']}} </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['дом']"> субъект РФ: {{card.data['Место регистрации']['дом']}} </span>
                          <span v-if="card.data && card.data['Место регистрации'] && card.data['Место регистрации']['квартира']"> субъект РФ: {{card.data['Место регистрации']['квартира']}} </span>
                      </div>
                      <div>
                          <span class="nameProperty">6. Местность: </span> <span v-if="card.data && card.data['Местность']">{{card.data['Местность']}}</span>
                      </div>
                      <div>
                          <span class="nameProperty">7. Полис ОМС: </span> 
                          <span v-if="card.data && card.data['Полис ОМС'] && card.data['Полис ОМС'].serial"> серия: {{card.data['Полис ОМС'].serial}} номер: {{card.data['Полис ОМС'].number}} </span>
                          <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">8. СНИЛС: </span> <span v-if="card.data && card.data['СНИЛС']"> {{card.data['СНИЛС']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">9. Наименование страховой медицинской организации: </span> <span v-if="card.data && card.data['Наименование страховой медицинской организации']"> {{card.data['Наименование страховой медицинской организации']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">10. Код категории льготы: </span> <span v-if="card.data && card.data['Код категории льготы']"> {{card.data['Код категории льготы']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">11. Документ: </span>
                          <template v-if="card.data && card.data['Документ']">
                            <span v-if="card.data['Документ'] && card.data['Документ'].type"> {{card.data['Документ'].type}} </span> <span v-else> - </span>
                            <span v-if="card.data['Документ'] && card.data['Документ'].serial">серия: {{card.data['Документ'].serial}} </span>
                            <span v-if="card.data['Документ'] && card.data['Документ'].number">номер: {{card.data['Документ'].number}} </span>
                          </template>
                          <template v-else>-</template>
                      </div>
                      <div>
                          <span class="nameProperty">12. Семейное положение: </span> <span v-if="card.data && card.data['Семейное положение']"> {{card.data['Семейное положение']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">13. Образование: </span> <span v-if="card.data && card.data['Образование']"> {{card.data['Образование']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">14. Занятость: </span> <span v-if="card.data && card.data['Занятость']"> {{card.data['Занятость']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">15. Инвалидность: </span> <span v-if="card.data && card.data['Инвалидность']"> {{card.data['Инвалидность']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">16. Место работы, должность: </span> <span v-if="card.data && card.data['Место работы, должность']"> {{card.data['Место работы, должность']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">17. Изменение места работы: </span> <span v-if="card.data && card.data['Изменение места работы']"> {{card.data['Изменение места работы']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">18. Изменение места регистрации: </span> <span v-if="card.data && card.data['Изменение места регистрации']"> {{card.data['Изменение места регистрации']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">19. Группа крови: </span> <span v-if="card.data && card.data['Группа крови']"> {{card.data['Группа крови']}}</span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">20. Rh-фактор: </span> <span v-if="card.data && card.data['Rh-фактор']"> 
                              <template v-if="card.data['Rh-фактор'] === '+'">положительный</template>
                              <template v-if="card.data['Rh-фактор'] === '-'">отрицательный</template>
                              </span> <span v-else> - </span>
                      </div>
                      <div>
                          <span class="nameProperty">21. Аллергические реакции: </span> <span v-if="card.data && card.data['Аллергические реакции']"> {{card.data['Аллергические реакции']}}</span> <span v-else> - </span>
                      </div>
                  </div>
                </slot>
              </div>

              <div class="modal-footer">
                <slot name="footer">
                  <button class="btn btn-sm btn-danger" @click="$emit('close')">
                    Закрыть
                  </button>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </transition>
</template>


<script>
export default {
    name: 'cardPatient',
    props: {
        card: Object
    },
    methods: {
        heightClass() {
        const maxHeight = document.documentElement.clientHeight;
        return { 'max-height': maxHeight-(maxHeight*0.5) + 'px', overflow: 'auto'};
      }
    }
    
};
</script>


<style lang="scss" scoped>

.nameProperty {
    font-weight: 600;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 40%;
  max-height: auto;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  overflow: auto;
  height: 50%;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>